import { StockDelta } from './stock-delta.model';
import { ProductStock } from './stock.types';
import { ProductStockWriteOp, resolveProductStockWrite } from './product-stock.model';

export type ProductStockUpdateContext = Pick<
  ProductStock,
  | 'establishmentId'
  | 'source'
  | 'uid'
  | 'reason'
  | 'systemReason'
  | 'lastOrderId'
  | 'lastOrderSequenceId'
  | 'lastOrderCancelReason'
  | 'lastInventoryCountId'
  | 'lastInventoryCountSequenceId'
  | 'lastTableSessionId'
  | 'lastTableSessionTableName'
  | 'lastTableSessionReason'
  | 'lastEntryId'
  | 'lastEntryName'
>;

/**
 * Traduce los `StockDelta` de un carrito en write ops de `productStock`. Cada delta proviene de un
 * record FINITO real (leído en la transacción), así que `item.stockQty` es el stock actual
 * autoritativo y el próximo absoluto es `item.stockQty + delta` — no hay re-lectura del producto ni
 * caso infinito (una entidad finita nunca pasa a infinita por una orden). Skip en `delta === 0`.
 */
export function getProductStockUpdatesForProducts(
  stockDeltas: StockDelta[],
  context: ProductStockUpdateContext,
): ProductStockWriteOp[] {
  const ops: ProductStockWriteOp[] = [];

  stockDeltas.forEach(({ item, delta }) => {
    // `getStockInfoDeltas` solo arma deltas para records FINITOS; el guard de `null` narrowea el tipo
    // (`stockQty` pasó a `number | null` por el lector defensivo) sin asserts ni fallback que enmascare.
    if (delta === 0 || item.stockQty === null) {
      return;
    }
    ops.push({
      entityId: item.id,
      write: resolveProductStockWrite({
        ...context,
        productId: item.productId,
        entityType: item.entityType,
        stockQty: item.stockQty + delta,
      }),
    });
  });

  return ops;
}
